import PageShell from "@/components/opsiq/PageShell";
import OpsWhyChoose from "@/components/opsiq/OpsWhyChoose";

export default function WhyOpsIQPage() {
  return (
    <PageShell
      testid="why-opsiq-page"
      title={<>Why organisations <span className="italic">choose OpsIQ.</span></>}
    >
      <OpsWhyChoose />
    </PageShell>
  );
}
